import { Component, OnInit } from '@angular/core';
import {MatDialog,MatDialogRef,MatDialogConfig} from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthService } from '../app-service/auth.service';
import { NewEntryScannerComponent } from '../new-entry-scanner/new-entry-scanner.component';
import { StopWatchComponent } from '../stop-watch/stop-watch.component';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  constructor(public dialog:MatDialog,private router: Router,private authService:AuthService) { }


  

  ngOnInit(): void {
  }
  Logout()
  {
      // this.authService.logOut()
  }
  onNewJob()
  {
     const dialogConfig=new MatDialogConfig();
    dialogConfig.disableClose=true;    
    const dialogRef=this.dialog.open(NewEntryScannerComponent,{
      panelClass:'app-dialog',

    });
  }
  onJobStatus()
  {
    this.router.navigate(['/workCompleted']);
    localStorage.removeItem('JobId')
  }
  
}
